import { RdsNavTreeItem } from './nav-tree-item.model';

/** Version of the NavTreeItem, designed to be used in a flat list */
export class RdsFlatNavTreeItem extends RdsNavTreeItem {
  constructor(node: RdsNavTreeItem, public level: number) {
    super(node.icon, node.label, node.url, node.children);
  }
}
